export default {"src":"/_next/static/media/print_icon.a95fe7ef.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};